import Vue from "vue";

import "normalize.css/normalize.css"; // A modern alternative to CSS resets
import "@/styles/index.scss"; // global css
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// import locale from 'element-ui/lib/locale/lang/en' // lang i18n

import "@/styles/theme/index.css"; // global css
import App from "./App";
import store from "./store";
import router from "./router";

import "@/icons/index.js"; // icon
import "@/permission"; // permission control

import directive from "./directive"; // directive
import dayjs from "dayjs";
import HighchartsVue from "highcharts-vue";

import Bus from "@/utils/bus";
import "@/utils/v-diretive.js"; // diretive
import comRuleData from "@/utils/comRuleData";
import handleClipboard from "@/utils/clipboard";
/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
Vue.prototype.$copyText = handleClipboard;
Vue.prototype.basePath =
  process.env.NODE_ENV === "development" ? "/auth" : process.env.BASE_API;
// if (process.env.NODE_ENV === 'development') {
//   const { mockXHR } = require('../mock')
//   mockXHR()
// }

// set ElementUI lang to EN
// Vue.use(ElementUI, { locale })
// 如果想要中文版 element-ui，按如下方式声明
Vue.directive("removeAriaHidden", {
  bind(el, binding) {
    const ariaEls = el.querySelectorAll(".el-radio__original");
    ariaEls.forEach((item) => {
      item.removeAttribute("aria-hidden");
    });
  },
});

Vue.use(ElementUI);
Vue.use(directive);
Vue.use(HighchartsVue);
Vue.prototype.dayjs = dayjs;
Vue.prototype.$bus = Bus;
Vue.prototype.comRuleData = comRuleData;

Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
});
